<template>
  <div>
    <v-data-table
      dense
      paginated
      class="main-table"
      height="auto"
      loading-text="Cargando... Por favor espere"
      :headers="headers"
      :items="items"
      :search="search"
      :items-per-page="5"
    >
      <template #[`item.actions`]="{ item }">
        <a style="cursor: pointer" @click="$emit('onPDFClick', item)">
          <v-progress-circular
            v-if="downloadingId === item.IDPAG"
            indeterminate
            size="24"
            width="2"
            color="red"
          />
          <v-icon v-else dense large color="red"> mdi-download-box </v-icon></a
        >
      </template>
    </v-data-table>
  </div>
</template>
<script>
  export default {
    name: 'PaymentReceiptTable',
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      search: {
        type: String,
        default: '',
      },
      downloadingId: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        headers: [
          { text: 'Fecha de pago', value: 'PEFECHA' },
          { text: 'Banco', value: 'BANCO' },
          { text: 'Referencia', value: 'REFER' },
          {
            text: 'Acciones',
            value: 'actions',
            sortable: false,
            align: 'center',
          },
        ],
      };
    },
  };
</script>
<style scoped src="@/assets/css/table.css"></style>
